import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function ErrorSection() {
  return <section className="w-full bg-bg-section py-12 md:py-20 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-3">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-accent-primary bg-opacity-10 rounded-full mb-4 md:mb-6" data-id="element-4">
            <AlertTriangleIcon className="h-6 w-6 md:h-8 md:w-8 text-accent-primary" aria-hidden="true" data-id="element-5" />
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-6" data-id="element-6">
            El error que deja tu empresa en papel
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-4 md:space-y-6 text-base md:text-lg text-text-secondary leading-relaxed" data-id="element-7">
          <p data-id="element-8">
            Registrar una LLC o Corporation es solo el primer paso. Sin una
            arquitectura empresarial completa, tu empresa existe solo en
            documentos pero no puede operar en el mundo real.
          </p>

          <div className="bg-bg-card border border-accent-primary border-opacity-20 rounded-lg p-4 md:p-6" data-id="element-9">
            <h3 className="text-lg md:text-xl font-semibold text-text-primary mb-3 md:mb-4" data-id="element-10">
              Sin estructura correcta enfrentas:
            </h3>
            <ul className="space-y-2 md:space-y-3" data-id="element-11">
              <li className="flex items-start" data-id="element-12">
                <span className="text-accent-primary mr-2 md:mr-3" data-id="element-13">•</span>
                <span data-id="element-14">
                  Bloqueos bancarios y rechazo de cuentas empresariales
                </span>
              </li>
              <li className="flex items-start" data-id="element-15">
                <span className="text-accent-primary mr-2 md:mr-3" data-id="element-16">•</span>
                <span data-id="element-17">Imposibilidad de usar Stripe o pasarelas de pago</span>
              </li>
              <li className="flex items-start" data-id="element-18">
                <span className="text-accent-primary mr-2 md:mr-3" data-id="element-19">•</span>
                <span data-id="element-20">Problemas de cumplimiento fiscal</span>
              </li>
              <li className="flex items-start" data-id="element-21">
                <span className="text-accent-primary mr-2 md:mr-3" data-id="element-22">•</span>
                <span data-id="element-23">Pérdida del velo corporativo</span>
              </li>
              <li className="flex items-start" data-id="element-24">
                <span className="text-accent-primary mr-2 md:mr-3" data-id="element-25">•</span>
                <span data-id="element-26">Empresa que no puede crecer ni escalar</span>
              </li>
            </ul>
          </div>

          <p className="text-lg md:text-xl font-semibold text-text-primary pt-2 md:pt-4" data-id="element-27">
            Una empresa real requiere arquitectura empresarial completa: legal,
            fiscal, financiera y de mantenimiento.
          </p>
        </motion.div>
      </div>
    </section>;
}